import { IFilterDto, IPagination, TFieldDefinition } from "../../common/model/Core.model"
import { IClientNestedDto } from "../client/Client.model"
import { IContactDto } from "../contact/Contact.model"
import { IAttachment } from "../media/Media.model"

export interface IContractDto {
  createdAt: string
  updatedAt: string
  organizationId: string
  client: IClientNestedDto
  id: string
  sequence: string
  legacyId?: string
  status: string
  startDate: string
  endDate: string
  documentTypeCode: string
  documentType: string
  serviceTypeCode: string
  serviceType: string
  serviceFrequencyCode: string
  serviceFrequency: string
  serviceResponseTime: string
  serviceAgreement: string
  serviceLocation: string
  comments?: string
  sellers?: IContactDto[]
  contacts?: IContactDto[]
  totalAsset: number
  totalAttachment: number
  totalReport: number
}

export interface IContractCreateRequestDto {
  createdBy?: string
  createdAt?: string
  organizationId?: string
  clientId: string
  legacyId?: string
  startDate: string
  endDate: string
  documentTypeCode: string
  documentType: string
  serviceTypeCode: string
  serviceType: string
  serviceFrequencyCode: string
  serviceFrequency: string
  serviceResponseTime: string
  serviceAgreement: string
  serviceLocation?: string
  comments?: string
  contacts: IContactDto[]
  sellers: IContactDto[]
  attachments: IAttachment[]
}

export interface IContractUpdateRequestDto {
  clientId: string
  id: string
  startDate: string
  endDate: string
  documentTypeCode: string
  documentType: string
  serviceTypeCode: string
  serviceType: string
  serviceFrequencyCode: string
  serviceFrequency: string
  serviceResponseTime?: string
  serviceAgreement?: string
  serviceLocation?: string
  comments?: string
  contacts: IContactDto[]
  sellers: IContactDto[]
  attachments: IAttachment[]
}

export interface IContractSearchRequestDto {
  pagination?: IPagination
  fields?: TFieldDefinition
  filters?: IFilterDto[]
}

// export interface IContractClient {
//   id: string
//   sequence: string
//   displayName: string
//   sector: string
// }

export enum IContractStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
}

export enum IContractFilter {
  CLIENT_HASH = 'CLIENT_HASH',
  CLIENT_ID = 'CLIENT_ID',
  CLIENT = 'CLIENT',
  HASH = 'HASH',
  ID = 'ID',
  STATUS = 'STATUS',
  DOCUMENT = 'DOCUMENT',
  SERVICE = 'SERVICE',
  FREQUENCY = 'FREQUENCY',
  ADDRESS = 'ADDRESS',
}

export interface IContractNestedDto {
  createdAt: string
  updatedAt: string
  organizationId: string
  id: string
  sequence: string
  status: string
  startDate: string
  endDate: string
  documentTypeCode: string
  documentType: string
  serviceTypeCode: string
  serviceType: string
  serviceFrequencyCode: string
  serviceFrequency: string
  serviceResponseTime: string
  serviceAgreement: string
  serviceLocation: string
  comments: string
}